var map = {
	"./logos/css3.png": "K4Rd",
	"./logos/git.png": "veVj",
	"./logos/gulp.png": "uyWQ",
	"./logos/html5.png": "zF1A",
	"./logos/jquery.png": "FPjn",
	"./logos/js.png": "2h36",
	"./logos/linux.png": "9ycd",
	"./logos/mysql.png": "lLH0",
	"./logos/photo.jpg": "yVLB",
	"./logos/php.png": "ODoz",
	"./logos/react.png": "i33q",
	"./logos/redux.png": "lgRi",
	"./logos/tailwindcss.png": "OFdQ",
	"./logos/ts.png": "roEz",
	"./logos/vite.png": "L5+F",
	"./logos/vue.png": "DGXF",
	"./logos/webpack.png": "5I6T",
	"./photo.jpg": "Jks+",
	"./slide1.webp": "TUJd",
	"./slide1_x2.webp": "9Lim",
	"./slide1_x4.webp": "VUzi",
	"./slide3.webp": "zTR2",
	"./slide3_x2.webp": "80BR",
	"./sources/background.jpg": "ZIRA",
	"./sources/logos/css3.png": "97BD",
	"./sources/logos/git.png": "jGKV",
	"./sources/logos/gulp.png": "h8Pb",
	"./sources/logos/html5.png": "xaCA",
	"./sources/logos/jquery.png": "ks/e",
	"./sources/logos/js.png": "owtE",
	"./sources/logos/linux.png": "ZWwa",
	"./sources/logos/mysql.png": "yd2I",
	"./sources/logos/php.png": "Zpae",
	"./sources/logos/react.png": "38Sv",
	"./sources/logos/redux.png": "LocH",
	"./sources/logos/vue.png": "7djs",
	"./sources/original-slides/slide1.jpg": "gHBA",
	"./sources/original-slides/slide1_x2.jpeg": "iMg/",
	"./sources/original-slides/slide1_x4.jpeg": "2NRX",
	"./sources/original-slides/slide3.jpg": "O4rL",
	"./sources/pexels-photo-239898.jpeg": "PA+7",
	"./sources/pexels-photo-60626.jpeg": "NU6d",
	"./sources/slide3.jpg": "LnN3",
	"./sources/taras.jpg": "rEsJ",
	"./taras.jpg": "aDNF"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1